import { Injectable } from '@angular/core';
import { McticHttpClient } from '@mctic/ng-core';
import { Observable } from 'rxjs';
import { LinhaPesquisa } from '../shared/model/linha-pesquisa.model';

@Injectable({
  providedIn: 'root'
})
export class LinhaPesquisaService {

  private readonly endpoint = 'sepin-backend/rest/linhas-pesquisa';

  constructor(private readonly mcticHttp: McticHttpClient) { }

  buscar(): Observable<LinhaPesquisa[]> {
    return this.mcticHttp.get<LinhaPesquisa[]>(this.endpoint);
  }
}
